import type { TFunction } from 'i18next';

/**
 * 초(seconds) 단위 숫자를 "N초 / N분 / N시간" 형태로 변환
 * - 60초 미만: 초로 표시
 * - 60분 미만: 분으로 표시
 * - 그 이상: 시간으로 표시
 */
export function formatDuration(seconds: number, t: TFunction): string {
  if (seconds >= 3600) {
    return t('time.hours', { count: Math.floor(seconds / 3600) });
  }
  if (seconds >= 60) {
    return t('time.minutes', { count: Math.floor(seconds / 60) });
  }
  return t('time.seconds', { count: seconds });
}
